export default "__VITE_ASSET__2be5ca52__"